// import debug from 'debug';

import api from '../../lib/api';

// const log = debug('huddle:store:middleware:inject');

// log({ api });

export default options => ({
  api: api(options),
});



// WEBPACK FOOTER //
// ./src/store/middleware/inject.js